module.exports = __webpack_public_path__ + "static/media/sketch1.dd39e53c.jpg";